export default __webpack_public_path__ + "static/media/caret-down.225d9415.svg";